import { put, takeLatest } from "redux-saga/effects";
import {
  fetchDynamoRequest,
  fetchDynamoSuccess,
  fetchDynamoFailure,
  fetchLAPDetailRequest,
  fetchLAPDetailSuccess,
  fetchLAPDetailFailure,
} from "./lapSlice";
import baseURL from "../../utils/config";

function* fetchDynamoSaga(action) {
  try {
    const { dynamoCode } = action.payload;

    if (!dynamoCode) {
      throw new Error("Dynamo code is required");
    }

    const response = yield fetch(`${baseURL}/api/lap/lap_dynamos/${encodeURIComponent(dynamoCode)}`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch Dynamo: ${response.status}`);
    }

    const result = yield response.json();
    const data = result.success ? result.data : result;

    yield put(fetchDynamoSuccess({ dynamoCode, data }));
  } catch (error) {
    console.error("Error in fetchDynamoSaga:", error);
    yield put(fetchDynamoFailure(error.message));
  }
}

function* fetchLAPDetailSaga(action) {
  try {
    const { lapId } = action.payload;

    if (!lapId) {
      throw new Error("LAP ID is required");
    }

    const response = yield fetch(`${baseURL}/api/lap/lap_live/${lapId}`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch LAP: ${response.status}`);
    }

    const result = yield response.json();
    const data = result.success ? result.data : result;

    yield put(fetchLAPDetailSuccess({ lapId, data }));
  } catch (error) {
    console.error("Error in fetchLAPDetailSaga:", error);
    yield put(fetchLAPDetailFailure(error.message));
  }
}

export function* watchLapSaga() {
  yield takeLatest(fetchDynamoRequest, fetchDynamoSaga);
  yield takeLatest(fetchLAPDetailRequest, fetchLAPDetailSaga);
}

